export default "__VITE_ASSET__C3Q4AL4T__"